export const RNRenderer = {
  findHostInstance_DEPRECATED: (_ref: any) => null,
};
